export { ConnectedPrivateRoute as PrivateRoute } from "./connected-private-route";
